import { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from '../common/Header';
import { Navigation } from '../common/Navigation';
import { RouteLoadingFallback } from '../common/RouteLoadingFallback';

export function MainLayout() {
    const location = useLocation();

    // Map pages are immersive, so hide standard layout elements or minimize them
    const isMapPage = location.pathname.startsWith('/map');

    // Some onboarding/auth pages might use this layout if wrapped incorrectly, 
    // but usually they are separate. Assuming this wraps main content.

    return (
        // overflow-hidden은 자손의 position: sticky를 무력화하므로 overflow-x-clip 사용
        // (배경 글로우의 가로 넘침은 차단하면서 sticky 헤더는 정상 동작)
        // 맵 페이지는 내부 스크롤 컨테이너가 자체적으로 스크롤을 담당하므로,
        // 뷰포트 고정 높이(h-screen)+overflow-hidden으로 바깥 문서 스크롤을 막아 이중 스크롤바를 방지한다.
        <div className={`bg-[var(--bg-main)] text-[var(--text-primary)] font-sans relative flex flex-col overflow-x-clip ${isMapPage ? 'h-screen overflow-hidden' : 'min-h-screen'}`}>
            {/* Ambient Background Glows */}
            {!isMapPage && (
                <>
                    <div
                        className="absolute top-[-15%] left-[-10%] w-[60vw] h-[60vw] rounded-full opacity-[0.06] pointer-events-none z-0 animate-float-slow"
                        style={{
                            background: 'radial-gradient(circle, var(--accent) 0%, transparent 75%)',
                            filter: 'blur(80px)',
                        }}
                    />
                    <div
                        className="absolute bottom-[-10%] right-[-10%] w-[55vw] h-[55vw] rounded-full opacity-[0.04] pointer-events-none z-0 animate-float-reverse"
                        style={{
                            background: 'radial-gradient(circle, var(--accent) 0%, transparent 75%)',
                            filter: 'blur(90px)',
                        }}
                    />
                </>
            )}

            {/* Header is now persistent across all pages, including immersive map pages */}
            <Header />

            {/* Main Content Area */}
            {/* Map pages need full width, other pages are constrained but wide enough for PC */}
            {/* min-h-0: flex 자식이 콘텐츠 크기만큼 강제로 늘어나는 것을 막아, 맵 페이지에서 남은 높이를 정확히 차지하고 내부 스크롤이 동작하게 함 */}
            <main className={`flex-1 min-h-0 w-full relative z-10 ${!isMapPage ? 'max-w-7xl mx-auto px-4 pb-28 pt-4' : ''}`}>
                {/* 헤더/네비는 그대로 유지한 채, 지연 로딩되는 페이지만 이 영역 안에서 대기 (깜빡임 방지) */}
                <Suspense fallback={<RouteLoadingFallback />}>
                    <Outlet />
                </Suspense>
            </main>

            {/* Navigation HUD - Persistent at bottom (fixed positioning, floats over content) */}
            <Navigation />
        </div>
    );
}
